import { useI18n as useVueI18n, type NamedValue } from 'vue-i18n'

import type { MessageKey, MessageSchema } from './schema'

/** `t()` restricted to the keys of the `en` schema, so `vue-tsc` refuses an unknown key (I18N.md §3). */
export type AppTranslate = (key: MessageKey, namedOrPlural?: NamedValue | number, plural?: number) => string

/**
 * The app's `useI18n()`: vue-i18n's global composer with a strict `t`. vue-i18n's own `t` accepts any string
 * (`<Key extends string>`), so modules import this one — ESLint forbids `useI18n` from 'vue-i18n' elsewhere.
 * The type parameter only keeps the documented `useI18n<{ message: MessageSchema }>()` form compiling.
 */
export function useI18n<_Schema extends { message: MessageSchema } = { message: MessageSchema }>() {
  const composer = useVueI18n<{ message: MessageSchema }>({ useScope: 'global' })
  return {
    t: composer.t as unknown as AppTranslate,
    /** Whether a key exists (dynamic keys of MODULE.md §2 enumerations). */
    te: (key: string): boolean => composer.te(key),
    d: composer.d,
    n: composer.n,
    locale: composer.locale,
  }
}
